import dataModel from '../../models/DataModel';
import Metadata from '../../helpers/metadata/Metadata';
import StoreItemProcessing from '../../helpers/StoreFunctions/StoreItemProcessing';

export default class DataSource {
  constructor(itemType, id, recordDescriptor, callBack, optionalOptions, parentId, altParentId, fromStoreOnly) {
    this._id = id && id.id ? id.id : typeof id == 'number' ? parseInt(id, 10) : id;
    this._recordDescriptor = recordDescriptor;
    this._optionalOptions = optionalOptions;
    this._parentId = parentId;
    this._altParentId = altParentId;
    this._fromStoreOnly = fromStoreOnly;
    this.get = this.get.bind(this);
    this.release = this.release.bind(this);
    this.unset = this.unset.bind(this);
    this.update = this.update.bind(this);
    this.delete = this.delete.bind(this);
    this.archive = this.archive.bind(this);
    if (callBack) {
      this._callBack = callBack.bind(this);
    }
    this._itemType = itemType;

    this.release = this.release.bind(this);
    this._processActionCable = this._processActionCable.bind(this);

    this._dao = dataModel[StoreItemProcessing.mapToPlural(this._itemType.toLowerCase()) + 'DAO'];

    if (this._itemType == 'Task') {
      dataModel.actionCableConnector.registerCallback(this._processActionCable, ['updateTaskAssignments', 'delete' + this._itemType, 'update' + this._itemType], [this._id], this._recordDescriptor);
    }
    else if (this._itemType == 'Project') {
      dataModel.actionCableConnector.registerCallback(this._processActionCable, ['updateProjectMemberAssignments', 'delete' + this._itemType, 'update' + this._itemType], [this._id], this._recordDescriptor);
    }
    else if (this._itemType == 'CompletionCriterion') {
      dataModel.actionCableConnector.registerCallback(this._processActionCable, ['deleteStep', 'updateStep'], [this._id], this._recordDescriptor);
    }
    else if (this._itemType == 'User') {
      dataModel.actionCableConnector.registerCallback(this._processActionCable, ['deactivateUser', 'delete' + this._itemType, 'update' + this._itemType], [this._id], this._recordDescriptor);
    }
    else if (this._itemType == 'Build') {
      if (this._id != 'root_build') {
        dataModel.actionCableConnector.registerCallback(this._processActionCable, ['delete' + this._itemType, 'update' + this._itemType], [this._id], this._recordDescriptor);
      }
    }
    else {
      dataModel.actionCableConnector.registerCallback(this._processActionCable, ['delete' + this._itemType, 'update' + this._itemType], [this._id], this._recordDescriptor);
    }
  }

  _processActionCable(fetchedData, acData) {
    if (this._id && this._id != 'removed') {
      let item = this._dao.findItem(this._id);
      if (item) {
        item = this._dao.mapToReturn(item, { recordDescriptor: this._recordDescriptor });
        this._callBack && this._callBack(item, null, acData, fetchedData);
      }
      else if (acData.type.indexOf('delete') >= 0) {
        this._callBack && this._callBack({ id: this._id }, null, acData);
      }
    }
  }

  release() {
    this._released = true;
    if (this._itemType == 'Task') {
      dataModel.actionCableConnector.unregisterCallback(this._processActionCable, ['updateTaskAssignments', 'delete' + this._itemType, 'update' + this._itemType], [this._id]);
    }
    else if (this._itemType == 'Project') {
      dataModel.actionCableConnector.unregisterCallback(this._processActionCable, ['updateProjectMemberAssignments', 'delete' + this._itemType, 'update' + this._itemType], [this._id]);
    }
    else if (this._itemType == 'CompletionCriterion') {
      dataModel.actionCableConnector.unregisterCallback(this._processActionCable, ['deleteStep', 'updateStep'], [this._id]);
    }
    else if (this._itemType == 'User') {
      dataModel.actionCableConnector.unregisterCallback(this._processActionCable, ['deactivateUser', 'delete' + this._itemType, 'update' + this._itemType], [this._id]);
    }
    else if (this._itemType == 'Build') {
      if (this._id != 'root_build') {
        dataModel.actionCableConnector.unregisterCallback(this._processActionCable, ['delete' + this._itemType, 'update' + this._itemType], [this._id]);
      }
    }
    else {
      dataModel.actionCableConnector.unregisterCallback(this._processActionCable, ['delete' + this._itemType, 'update' + this._itemType], [this._id]);
    }
    this._callBack = null;
    this._id = 'removed';
  }

  static create(itemType, newItem, recordDescriptor, callBack) {
    return new Promise((resolve) => {
      const eventMetaDatam = Metadata.generateMetadatum();
      const dao = dataModel[StoreItemProcessing.mapToPlural(itemType.toLowerCase()) + 'DAO'];

      return resolve(dao['create' + itemType](newItem, eventMetaDatam, { recordDescriptor: recordDescriptor }).then(item => {
        if (item && item.id) {
          if (callBack) {
            callBack(item, 'create');
            return item;
          }
        }
      }));
    });
  }

  unset() {
    if (this._id && !this._id != 'removed') {
      this._dao['unset' + this._itemType](this._id);
    }
  }

  get(optionalAction, checkArrays) {
    return new Promise((resolve) => {
      if (this._id && !this._id != 'removed') {
        if (this._fromStoreOnly) {
          let item = this._dao.findItem(this._id);
          if (item) {
            item = this._dao.mapToReturn(item, { recordDescriptor: this._recordDescriptor });
            this._callBack && !this._released && this._callBack(item, null, null, null);
          }
        }
        else if (this._itemType == 'Project') {
          return resolve(this._dao['get' + this._itemType](this._id, { recordDescriptor: this._recordDescriptor, checkArrays: checkArrays, ...this._optionalOptions }, false,
            item => {
              if (item) {
                this._callBack && !this._released && this._callBack(item, 'prefetch');
              }
            }).then(item => {
              this._callBack && !this._released && this._callBack(item, optionalAction);
              return item;
            }));
        }
        else if (this._itemType == 'ProjectTemplate') {
          return resolve(this._dao['get' + this._itemType](this._id, { recordDescriptor: this._recordDescriptor, checkArrays: checkArrays, ...this._optionalOptions }, false,
            item => {
              if (item) {
                this._callBack && !this._released && this._callBack(item, 'prefetch');
              }
            }).then(item => {
              this._callBack && !this._released && this._callBack(item, optionalAction);
              return item;
            }));
        }
        else {
          return resolve(this._dao['get' + this._itemType](this._id, { checkArrays: checkArrays, recordDescriptor: this._recordDescriptor, ...this._optionalOptions },
            item => {
              if (item) {
                this._callBack && !this._released && this._callBack(item, 'prefetch');
              }
            }, this._parentId, this._altParentId).then(item => {
              this._callBack && !this._released && this._callBack(item, optionalAction);
              return item;
            }));
        }
      }
    });
  }

  set(item) {
    const normalizedItem = this._dao.normalizeItem(item, { recordDescriptor: this._recordDescriptor });
    this._dao.setItemInStore(normalizedItem);
    this._callBack && !this._released && this._callBack(item);
  }

  update(updatedItem, action) {
    return new Promise((resolve) => {
      if (this._id && !this._id != 'removed') {
        return resolve(this._dao['update' + this._itemType](updatedItem, this._recordDescriptor).then(item => {
          this._callBack && !this._released && this._callBack(item, 'update');
          return item;
        }));
      }
    });
  }

  delete() {
    return new Promise((resolve) => {
      if (this._id && !this._id != 'removed') {
        return resolve(this._dao['delete' + this._itemType](this._id).then(response => {
          this.release();
          this._callBack && !this._released && this._callBack(null, 'delete');
        }));
      }
    });
  }

  performAction(action, param1, param2, param3, param4, param5, param6, param7, param8) {
    return this._dao[action](param1, param2, param3, param4, param5, param6, param7, param8).then((value) => {
      if (this._id) {
        let item = this._dao.findItem(this._id);
        item = this._dao.mapToReturn(item, { recordDescriptor: this._recordDescriptor });
        this._callBack && !this._released && this._callBack(item, action);
        return item;
      }
      else {
        this._callBack && !this._released && this._callBack(value, action);
        return value;
      }
    });
  }

  archive() {
    if (this._id && !this._id != 'removed') {
      this._dao['archive' + this._itemType](this._id).then(response => {
        this.release();
        this._callBack && !this._released && this._callBack(null, 'archive');
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/dao/DataSource/DataSource.js